//应用配置
module.exports = {
    appTitle:"云图新产品-内测环境",
    apiPath: "/api",
  };
  